import * as React from 'react';
import { TrackTile } from './track-tile';
import { CSSProperties } from 'react';
import { px, viewWidth } from 'csx';
import { mediaTablet, mediaMobileOnly } from '../theme/media';
import { style } from 'typestyle';
import { horizontallySpaced } from 'csstips';
import { Carousel } from './carousel';
import { observer } from 'mobx-react';
import { colorSubtle } from '../theme/color';
import { ArtistSchema, TrackSchema } from '../types/schema';
import { ImagePreloader } from '../types/fn';
import { AnalyticsController } from '../modules/analytics/controller';

export interface PageHomeJustAddedTracksProps {
  preload: ImagePreloader;
  tracks: Array<TrackSchema>;
  onClickLink(event: React.MouseEvent<any>): void;
  PlayButton: any;
  AddRemove: any;
  Favourite: any;
  analytics: AnalyticsController;
}

export const constants = {
  mobileSize: viewWidth(85),
  desktopSize: viewWidth(25),
};

@observer
export class PageHomeJustAddedTracks extends React.Component<PageHomeJustAddedTracksProps, any> {
  render() {
    const { tracks, PlayButton, Favourite, AddRemove, onClickLink, preload, analytics } = this.props;

    return (
      <Carousel
        className={PageHomeJustAddedTracks.styles.carousel}
        innerClassName={PageHomeJustAddedTracks.styles.carouselInner}
        spacerClassName={PageHomeJustAddedTracks.styles.carouselSpacer}
      >
        {tracks.map((track, index) => (
          <TrackTile
            analytics={analytics}
            scale={1.2}
            key={index}
            track={track}
            PlayButton={PlayButton}
            AddRemove={AddRemove}
            Favourite={Favourite}
            onClickLink={onClickLink}
            className={PageHomeJustAddedTracks.styles.track}
            preload={preload}
          />
        ))}
      </Carousel>
    );
  }

  static styles = {
    carousel: style(mediaMobileOnly({ height: constants.mobileSize }), mediaTablet({ height: constants.desktopSize })),
    carouselInner: style(
      { ...horizontallySpaced(20) },
      mediaMobileOnly({ padding: '0 20px' }),
      mediaTablet({ padding: '0 40px' }),
    ),
    carouselSpacer: style(
      { flexShrink: 0 },
      mediaMobileOnly({ width: px(1), marginLeft: px(-1) }),
      mediaTablet({ width: px(40) }),
    ),
    track: style(
      {
        height: 'auto !important',
        boxShadow: `0 0 1px ${colorSubtle.toString()}`,
      },
      mediaMobileOnly({ width: constants.mobileSize }),
      mediaTablet({ width: constants.desktopSize }),
    ),
  };
}
